/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface CollectionViewUnsavedSignature {
  Args: {
    isDefault: boolean;
    onDiscard?: (e: Event) => void;
    onSave?: (e: Event) => void;
  };
  Element: HTMLDivElement;
}

const CollectionViewUnsavedComponent =
  templateOnly<CollectionViewUnsavedSignature>('CollectionView::Unsaved');

export default CollectionViewUnsavedComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::Unsaved': typeof CollectionViewUnsavedComponent;
    'collection-view/unsaved': typeof CollectionViewUnsavedComponent;
  }
}
